module.exports = __webpack_public_path__ + "static/media/marinex_arrow_right_blue.34ed5d57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/marinex_arrow_right_blue.svg
// module id = 292
// module chunks = 0